import React, { useContext, useEffect } from 'react';
import { BranchFranchiseServiceProvider as StateProvider, BranchFranchiseCompareContext } from './branchServicesProvider';
import { Button, CircularProgress, FormControlLabel, Grid, InputLabel, Switch, TableCell, Typography, withStyles } from '@material-ui/core';
import { MultipleSelectWithMoreOp, MultiselectWithoutCheckbox, SelectBox } from '../../../../Core/FormInput';
import './branchService.scss';
import ServiceTable from './branchServiceTabel';
import AccountCodeHistory from './accounrCodeHistory';
import DialogComp from '../../../../Core/Modal/dialogModal';
import ServiceTableYTD from './branchServiceYTD';
import { useRef } from 'react';
import moment from 'moment';
import * as XLSX from 'xlsx';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import AppContext from '../../../../App/AppContext';
// import { fontWeight } from 'html2canvas/dist/types/css/property-descriptors/font-weight';
import ExcelJS from 'exceljs';

const GlobalCss = withStyles({
    '@global': {
        ' .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
            padding: '2px',
            fontWeight: 800
        },
        '.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
            height: '50px',
            fontWeight: 800
        },
        ' .MuiAutocomplete-tag': {
            maxWidth: '100%'
        },
        '.MuiSelect-outlined.MuiSelect-outlined': {
            padding: '16px !important;',
            fontWeight: 600,
            fontSize: 15
        }
    }
})(() => null);

const BranchAndFrenchiseComparService = (props) => {
    // const tableRef = useRef();
    const {
        state,
        handleBranch,
        handleFranchise,
        screenDetails,
        dropDown,
        handlChange,
        handleAccountCodes,
        accountData,
        periodList,
        handleShowYTD,
        loader,
        tableRef,
        setScreenDashboardID,
        screenDashboardID,
        handleDashboardChange,
        screenLoader
    } = useContext(BranchFranchiseCompareContext);

    const { mAccountMenus = [] } = useContext(AppContext);

    let PrintFilterArray = [
        {
            name: 'Branch Name',
            value: state.branchNewList?.map((k) => k.name).join(','),
            isRow: true
        },
        {
            name: 'Franchise',
            value: state.franchise?.map((k) => k.name).join(','),
            isRow: true
        }
    ];
    let printFilterArray2 = [
        {
            name: 'Period',
            value: periodList.find((k) => k.id === state.period)?.name,
            isRow: false
        },
        {
            name: 'Year',
            value: state.yearID,
            isRow: false
        }
    ];

    const handleDownload = () => {
        const formattedDate = moment().format('DD-MM-YYYY_HH-mm');
        const fileTitle = `${screenDetails.name}_${formattedDate}`;

        const titleHTML = `
        <div style="margin: 5px; width:98.4%">
            <div style="
                background-color: ${screenDetails.bgColor};
                color: ${screenDetails.txtColor};
                padding: 5px 0px; 
                font-size: 17px;
                font-weight: 600;
                text-align: center;
            ">
                ${screenDetails.name}
            </div>
        </div>`;

        const filterHTML = `
        <div style="display: flex; flex-wrap: wrap; gap: 10px; margin: 5px;">
            ${PrintFilterArray.map(
                (filter) =>
                    filter.value &&
                    `
                <div style="display: flex; width: ${filter.isRow ? '100%' : '50%'}; flex-direction: row;">
                    <div style="
                        background-color: ${screenDetails.bgColor};
                        color: ${screenDetails.txtColor};
                        font-weight: bold;
                        padding: 5px 10px;
                        width: 15%;
                    ">
                        ${filter.name}
                    </div>
                    <div style="
                        width: 85%;
                        background-color: white;
                        color: black;
                        border: 1px solid #ccc;
                        padding: 6px 10px;
                    ">
                        ${filter.value}
                    </div>
                </div>`
            ).join('')}
        </div>`;

        const filterHTML_2 = `
         <div style="display: flex; flex-wrap: wrap; gap: 10px; margin: 5px;">
             ${printFilterArray2
                 .map(
                     (filter) =>
                         `
                <div style="display: flex; width: '50%'; flex-direction: 'row';">
                    <div style="
                        background-color: ${screenDetails.bgColor};
                        color: ${screenDetails.txtColor};
                        font-weight: bold;
                        padding: 5px 10px;
                    width: 40%;
                    ">
                        ${filter.name}
                    </div>
                    <div style="
                        width: 60%;
                        background-color: white;
                        color: black;
                        border: 1px solid #ccc;
                        padding: 6px 10px;
                    ">
                        ${filter.value}
                    </div>
                    </div>
              `
                 )
                 .join('')}
          </div>
        `;

        const content = tableRef.current.innerHTML;
        const printWindow = window.open('', fileTitle);
        printWindow.document.write(`
        <html>
            <head>
                <title>${fileTitle}</title>
                <style>
                    @media print {
                        @page {
                            margin: 10px;
                        }
                        body {
                            margin: 10px;
                        }
                    }
                    body {
                        font-family: Arial, sans-serif;
                        padding: 20px;
                        margin: 0;
                    }
                    .title {
                        background-color: #007bff;
                        color: white;
                        padding: 20px;
                        font-size: 24px;
                        text-align: center;
                        margin: 0;
                    }
                    .filters {
                        display: flex;
                        flex-wrap: wrap;
                        padding: 20px;
                        background-color: #f0f0f0;
                        gap: 15px;
                    }
                    .filter {
                        display: flex;
                        flex-direction: column;
                        font-size: 14px;
                    }
                    .filter-label {
                        color: #007bff;
                        font-weight: bold;
                        margin-bottom: 4px;
                    }
                    .filter-value {
                        background: white;
                        border: 1px solid #ccc;
                        padding: 6px 10px;
                        border-radius: 4px;
                        min-width: 100px;
                    }
                    table {
                        border-collapse: collapse;
                        width: 100%;
                        margin: 0px;
                    }
                    th, td {
                        border: 1px solid #000;
                        padding: 8px;
                        text-align: left;
                    }
                </style>
            </head>
            <body>
                ${titleHTML}
                ${filterHTML}
                ${filterHTML_2}
                ${content}
                <script>
                    window.onload = function() {
                        window.print();
                        window.onafterprint = function() {
                            window.close();
                        }
                    };
                </script>
            </body>
        </html>
    `);
        printWindow.document.close();
    };

    const rgbToHex = (rgb) => {
        const result = /^rgba?\((\d+),\s*(\d+),\s*(\d+)/i.exec(rgb);
        return result
            ? result
                  .slice(1, 4)
                  .map((x) => parseInt(x).toString(16).padStart(2, '0'))
                  .join('')
                  .toUpperCase()
            : 'FFFFFF';
    };

    function getCellAddress(row, col) {
        let columnLetter = '';
        while (col > 0) {
            const rem = (col - 1) % 26;
            columnLetter = String.fromCharCode(65 + rem) + columnLetter;
            col = Math.floor((col - 1) / 26);
        }
        return `${columnLetter}${row}`;
    }

    const addMultiRowTableHeader = (worksheet, table, startRow = 1) => {
        const theadRows = Array.from(table.querySelectorAll('thead tr'));
        const mergeTracker = []; // Track merged positions to skip overlaps

        theadRows.forEach((tr, rowOffset) => {
            const cells = Array.from(tr.children);
            const excelRow = worksheet.getRow(startRow + rowOffset);

            let colPointer = 1;

            cells.forEach((cell) => {
                // Skip columns already merged
                while (mergeTracker[rowOffset]?.includes(colPointer)) colPointer++;

                const text = cell.innerText.trim();
                const colspan = parseInt(cell.getAttribute('colspan') || '1');
                const rowspan = parseInt(cell.getAttribute('rowspan') || '1');

                const cellRef = excelRow.getCell(colPointer);
                cellRef.value = text;

                // Apply computed styles
                const style = window.getComputedStyle(cell);
                const bgColorHex = rgbToHex(style.backgroundColor);
                const textColorHex = rgbToHex(style.color);

                cellRef.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: bgColorHex || 'D9D9D9' }
                };
                cellRef.font = {
                    bold: true,
                    color: { argb: textColorHex || '000000' }
                };
                cellRef.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };

                // Merge cells if needed
                if (colspan > 1 || rowspan > 1) {
                    const startCell = getCellAddress(startRow + rowOffset, colPointer);
                    const endCell = getCellAddress(startRow + rowOffset + rowspan - 1, colPointer + colspan - 1);
                    worksheet.mergeCells(`${startCell}:${endCell}`);

                    // Track merged positions to skip in future iterations
                    for (let i = 0; i < rowspan; i++) {
                        if (!mergeTracker[rowOffset + i]) mergeTracker[rowOffset + i] = [];
                        for (let j = 0; j < colspan; j++) {
                            mergeTracker[rowOffset + i].push(colPointer + j);
                        }
                    }
                }

                colPointer += colspan;
            });
        });

        return startRow + theadRows.length; // Return new row index after header
    };

    const handleExportStyledExcelJS = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');

        // 1. Title row
        worksheet.mergeCells('A1:B1');
        const titleCell = worksheet.getCell('A1');
        titleCell.value = screenDetails.name;
        titleCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: screenDetails.bgColor.replace('#', '') || '0000FF' }
        };
        titleCell.font = {
            color: { argb: screenDetails.txtColor.replace('#', '') || 'FFFFFF' },
            bold: true,
            size: 14
        };
        titleCell.alignment = { horizontal: 'center', vertical: 'middle' };

        // 2. Filter rows
        let currentRow = 2;
        const allFilters = [...PrintFilterArray, ...printFilterArray2];

        allFilters.forEach((filter) => {
            if (!filter.value) return;

            const row = worksheet.getRow(currentRow);
            row.getCell(1).value = filter.name;
            row.getCell(2).value = filter.value;

            row.getCell(1).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: screenDetails.bgColor.replace('#', '') }
            };
            row.getCell(1).font = {
                color: { argb: screenDetails.txtColor.replace('#', '') },
                bold: true
            };
            row.getCell(1).alignment = { horizontal: 'left' };

            row.getCell(2).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF' }
            };
            row.getCell(2).font = {
                color: { argb: '000000' }
            };
            row.getCell(2).alignment = { horizontal: 'right' };

            currentRow++;
        });

        // 3. Add empty row
        currentRow++;

        // 4. Add multi-row table header
        const table = tableRef.current;
        currentRow = addMultiRowTableHeader(worksheet, table, currentRow);

        // 5. Add table body
        const rows = Array.from(table.querySelectorAll('tbody tr'));
        rows.forEach((tr) => {
            const cells = Array.from(tr.querySelectorAll('td'));
            const rowData = cells.map((td) => td.innerText.trim());
            const newRow = worksheet.addRow(rowData);

            cells.forEach((td, i) => {
                const style = window.getComputedStyle(td);
                const cell = newRow.getCell(i + 1);

                const bgColorHex = rgbToHex(style.backgroundColor === 'rgba(0, 0, 0, 0)' ? 'rgba(255, 255, 255, 1)' : style.backgroundColor);
                const textColorHex = rgbToHex(style.color);

                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: bgColorHex || 'FFFFFF' }
                };
                cell.font = {
                    color: { argb: textColorHex || '000000' }
                };
                cell.alignment = {
                    horizontal: style.textAlign || 'left',
                    vertical: 'middle'
                };
            });
        });

        // 6. Auto width
        worksheet.columns.forEach((column) => {
            let maxLength = 10;
            column.eachCell({ includeEmpty: true }, (cell) => {
                const len = (cell.value || '').toString().length;
                if (len > maxLength) maxLength = len;
            });
            column.width = maxLength + 2;
        });

        // 7. Download file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const filename = `${screenDetails.name}_${moment().format('DD-MM-YYYY_HH-mm')}.xlsx`;

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleExportStyledXLSX = () => {
        const wb = XLSX.utils.book_new();

        // 1. Title row
        const titleRow = [[screenDetails.name]];

        // 2. Filter rows
        const filterRows = PrintFilterArray.map((item) => [item.name, Array.isArray(item.value) ? item.value.join(', ') : item.value]);
        filterRows.push(...printFilterArray2.map((item) => [item.name, Array.isArray(item.value) ? item.value.join(', ') : item.value]));

        // 3. Table content
        const tableData = XLSX.utils.table_to_sheet(tableRef.current);
        const tableJson = XLSX.utils.sheet_to_json(tableData, { header: 1 });

        // 4. Combine all data
        const fullData = [...titleRow, ...filterRows, [], ...tableJson];
        const ws = XLSX.utils.aoa_to_sheet(fullData);

        // 5. Set alignment and styles for all cells
        const range = XLSX.utils.decode_range(ws['!ref']);
        for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
                const cell = ws[cellRef];
                if (!cell || typeof cell.v === 'undefined') continue;

                // Ensure cell.s exists
                cell.s = cell.s || {};

                // Always left-align 1st column (A), right-align others
                cell.s.alignment = {
                    horizontal: C === 0 ? 'left' : 'right',
                    vertical: 'center',
                    wrapText: true // Optional, helps long text wrap
                };
            }
        }

        // 6. Style title cell (A1)
        ws['A1'].s = {
            fill: { fgColor: { rgb: screenDetails.bgColor.replace('#', '') || '0000FF' } },
            font: { color: { rgb: screenDetails.txtColor.replace('#', '') || 'FFFFFF' }, bold: true },
            alignment: { horizontal: 'center' }
        };

        // 7. Style filter labels (left aligned) and values (right aligned)
        for (let i = 0; i < filterRows.length; i++) {
            const labelCell = `A${i + 2}`;
            const valueCell = `B${i + 2}`;

            if (ws[labelCell]) {
                ws[labelCell].s = {
                    fill: { fgColor: { rgb: screenDetails.bgColor.replace('#', '') } },
                    font: { color: { rgb: screenDetails.txtColor.replace('#', '') }, bold: true },
                    alignment: { horizontal: 'left' }
                };
            }

            if (ws[valueCell]) {
                ws[valueCell].s = {
                    fill: { fgColor: { rgb: 'FFFFFF' } },
                    font: { color: { rgb: '000000' } },
                    alignment: { horizontal: 'right' }
                };
            }
        }

        // 8. Set dynamic column widths
        const colWidths = fullData[0].map((_, colIndex) => {
            let maxLen = 5;
            fullData.forEach((row) => {
                const cell = row[colIndex];
                if (cell && cell.toString) {
                    const len = cell.toString().length;
                    if (len > maxLen) maxLen = len;
                }
            });
            return { wch: maxLen + 1 };
        });
        ws['!cols'] = colWidths;

        // 9. Finalize and download
        wb.SheetNames.push('Sheet1');
        wb.Sheets['Sheet1'] = ws;

        const filename = `${screenDetails.name}_${moment().format('DD-MM-YYYY_HH-mm')}.xlsx`;
        XLSX.writeFile(wb, filename, { cellStyles: true });
    };

    return (
        <div style={{ padding: 10 }}>
            <GlobalCss />

            <Grid container spacing={1}>
                <Grid item xs={12} style={{ backgroundColor: screenDetails.bgColor, color: screenDetails.txtColor, padding: 3, fontSize: 17, fontWeight: 500 }}>
                    <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                        {/* <Grid item></Grid> */}
                        <Grid item>
                            <select
                                value={screenDashboardID}
                                className="custom-select"
                                style={{ padding: 5, width: '100%', fontSize: 17, border: '3px solid rgba(0,0,0,0.3)' }}
                                onChange={handleDashboardChange}
                            >
                                {/* <option value="">-- Select --</option> */}
                                {mAccountMenus.menus.map((opt) => (
                                    <option key={opt.id} value={opt.id}>
                                        {opt.name}
                                    </option>
                                ))}
                            </select>
                        </Grid>

                        <Grid item>
                            {' '}
                            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 10 }}>
                                {/* <Button style={{ marginRight: 10, color: 'white' }} onClick={handleExportStyledXLSX}> */}
                                <span title="Click here to download dashboard in Excel format">
                                    <CloudDownloadIcon
                                        style={{ color: screenDetails.txtColor, cursor: 'pointer', fontSize: 29 }}
                                        onClick={handleExportStyledExcelJS}
                                    />
                                </span>
                                {/* </Button>{' '} */}
                                {/* <Button style={{ marginRight: 10, color: 'white' }} onClick={handleDownload}> */}
                                <span title="Click here to download dashboard in PDF format (make sure to tick Background graphics to add background colours)">
                                    <PictureAsPdfIcon style={{ color: screenDetails.txtColor, cursor: 'pointer', fontSize: 29 }} onClick={handleDownload} />
                                </span>
                                <span>
                                    <span style={{ marginRight: 5 }}>MTD</span>{' '}
                                    <FormControlLabel control={<Switch checked={state.showYTD} onChange={handleShowYTD} />} label="YTD" />
                                </span>
                            </span>
                        </Grid>
                    </Grid>
                    <Typography></Typography>
                </Grid>

                {screenLoader ? (
                    <Grid container alignItems="center" justifyContent="center" style={{ height: '50vh' }}>
                        <Grid item>
                            <div>
                                <CircularProgress />
                            </div>
                            <div>Please wait while we are loading your screen...</div>
                        </Grid>
                    </Grid>
                ) : (
                    <Grid item xs={12}>
                        <Grid container spacing={1}>
                            {screenDetails.hasBranch && (
                                <Grid item lg={screenDetails.hasFranchise ? 4 : 6} md={4} sm={6} xs={12}>
                                    <InputLabel shrink style={{ marginBottom: -6 }}>
                                        Branch Name
                                    </InputLabel>
                                    <MultipleSelectWithMoreOp options={dropDown.branch || []} value={state.branchNewList || []} onChange={handleBranch} />
                                </Grid>
                            )}
                            {screenDetails.hasFranchise && (
                                <Grid item md={4} sm={6} xs={12} lg={4}>
                                    <InputLabel shrink style={{ marginBottom: -6 }}>
                                        Franchise
                                    </InputLabel>
                                    <MultipleSelectWithMoreOp options={dropDown.franchise || []} value={state.franchise || []} onChange={handleFranchise} />
                                </Grid>
                            )}
                            {screenDetails.hasPeriod && (
                                <Grid item md={4} sm={6} xs={12} lg={screenDetails.hasFranchise ? 2 : 3}>
                                    <SelectBox List={periodList} name={'period'} onChange={handlChange} inputLabel={'Period'} value={state.period} />
                                </Grid>
                            )}

                            {screenDetails.hasYear && (
                                <Grid item md={4} sm={6} xs={12} lg={screenDetails.hasFranchise ? 2 : 3}>
                                    <SelectBox List={dropDown.year || []} name={'yearID'} onChange={handlChange} inputLabel={'Year'} value={state.yearID} />
                                </Grid>
                            )}
                        </Grid>
                        <Grid item xs={12} ref={tableRef}>
                            {loader ? <CircularProgress /> : state.showYTD ? <ServiceTableYTD /> : <ServiceTable />}
                        </Grid>
                    </Grid>
                )}
            </Grid>
            {state.openAccountCodes ? (
                <DialogComp
                    maxWidth="lg"
                    onClose={handleAccountCodes}
                    title={
                        <div>
                            {accountData.catName}
                            <small style={{ fontSize: 12, marginLeft: 10 }}>{accountData.mainCat}</small>
                        </div>
                    }
                >
                    <AccountCodeHistory accountData={accountData} state={state} />
                </DialogComp>
            ) : null}
        </div>
    );
};
const BranchCompare = (props) => {
    return (
        <StateProvider {...props}>
            <BranchAndFrenchiseComparService {...props} />
        </StateProvider>
    );
};
export default BranchCompare;
